import { useOutletContext, useParams } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";
import shouldEnableInvoices from "../../invoices/utils/shouldEnableInvoices";

import OrderView from "../views/OrderView/OrderView";

export default function Order() {
	const { id } = useParams();
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("orders.view")) {
		return <Unauthorized />;
	}

	return (
		<OrderView
			id={id}
			enableInvoices={shouldEnableInvoices(organization.id) && hasRight("billing.createInvoice")}
			organization={organization}
		/>
	);
}
